import { twMerge } from 'tailwind-merge';
import { formatThousands } from '../../utils/string.utils';

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
}: {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, currentPage + 2);

      if (startPage > 1) {
        pages.push(1);
        if (startPage > 2) {
          pages.push('...');
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pages.push('...');
        }
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="pagination justify-center max-sm:w-full">
      <button
        className="btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <i className="ki-outline ki-black-left"></i>
      </button>

      {pageNumbers.map((page, index) =>
        page === '...' ? (
          <span key={`page_${index}`} className="btn disabled -mx-2">
            ...
          </span>
        ) : (
          <button
            key={page}
            className={twMerge(
              'btn !px-2.5 !w-max',
              page === currentPage && 'active',
            )}
            onClick={() => onPageChange(page)}
          >
            {formatThousands(page)}
          </button>
        ),
      )}

      <button
        className="btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <i className="ki-outline ki-black-right"></i>
      </button>
    </div>
  );
};

export default Pagination;
